<template>
  <div v-if="returnOrder && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="returnOrder"
    />
  </div>
</template>
<script>
import ReturnOrders from "@/api/return_orders";
import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    returnOrder: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("orderReturn").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          this.formater = formater;

          //获取单据详情
          ReturnOrders.returnOrdersPrint(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.returnOrder = response.data.return_orders;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>